<template>
    <svg aria-hidden="true" focusable="false" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.2383 8.22728C16.2383 9.45114 15.2311 10.4546 13.9746 10.4546C12.7182 10.4546 11.711 9.45114 11.711 8.22728C11.711 7.00341 12.7182 6 13.9746 6C15.2311 6 16.2383 7.00341 16.2383 8.22728Z"
            stroke="black"
            stroke-miterlimit="10" />
        <path d="M18.5 13.8794V17H9.5V13.8794C9.5 13.1304 10.117 12.5143 10.89 12.5143H17.11C17.8853 12.5143 18.5 13.1326 18.5 13.8794Z" stroke="black" stroke-miterlimit="10" />
        <path
            d="M9.78594 5.90909C9.78594 7.52883 8.5121 8.81819 6.96956 8.81819C5.42702 8.81819 4.15318 7.52883 4.15318 5.90909C4.15318 4.28936 5.42702 3 6.96956 3C8.5121 3 9.78594 4.28936 9.78594 5.90909Z"
            stroke="black"
            stroke-miterlimit="10" />
        <path
            d="M12.4413 17H1.56284C1.55134 17 1.53823 16.996 1.52478 16.9822C1.51124 16.9684 1.50082 16.9475 1.5 16.9211V12.9743C1.5 11.9479 2.30574 11.1429 3.26803 11.1429H10.732C11.6973 11.1429 12.5 11.951 12.5 12.9743V16.9257C12.5 16.9798 12.4608 17 12.4413 17Z"
            fill="white"
            stroke="black"
            stroke-miterlimit="10" />
    </svg>
</template>
